export enum EEvChargerStatus {
  AVAILABLE = "AVAILABLE",
  PREPARING = "PREPARING",
  CHARGING = "CHARGING",
  SUSPENDED_EVSE = "SUSPENDED_EVSE",
  SUSPENDED_EV = "SUSPENDED_EV",
  FINISHING = "FINISHING",
  RESERVED = "RESERVED",
  UNAVAILABLE = "UNAVAILABLE",
  FAULTED = "FAULTED",
  OFFLINE = "OFFLINE",
}
